'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbLicenseplate.$inject = ['ValidationService', 'FormattingService'];


var _module = _angular2.default.module('cb.Licenseplate', []);

_module.directive('cbLicenseplate', cbLicenseplate);

exports.default = _module;

/**
 * cb-licenseplate
 *
 * Add this directive to an input element to apply the license plate
 * validator and formatter.
 */

function cbLicenseplate(ValidationService, FormattingService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attr, ngModel) {

            function validator(value) {
                if (ngModel.$isEmpty(value)) {
                    return true;
                }

                return ValidationService.validateLicenseplate(value);
            }

            function parser(value) {
                if (ngModel.$isEmpty(value)) {
                    return null;
                }

                ngModel.$setViewValue(FormattingService.formatLicenseplate(value));
                ngModel.$commitViewValue();
                ngModel.$render();
                return FormattingService.formatLicenseplate(value);
            }

            ngModel.$parsers.push(parser);
            ngModel.$formatters.push(parser);

            ngModel.$validators['licenseplate'] = validator;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/licenseplate/cb-licenseplate.directive.js
// module id = 793
// module chunks = 0